import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@icons';
import cls from 'classnames';
import React, { useMemo } from 'react';
import styles from './list-item.module.scss';
const ListItemContent = React.memo(({ name, selected, showCheck, textColor, textColorSelected, RTL, highlightSelection, size = 'sm', }) => {
    const ref = React.useRef(null);
    const listOptionClass = cls([styles.value_wrapper], {
        [styles.highlight_selection]: highlightSelection,
        [styles.no_icon]: !showCheck,
        [styles.rtl]: RTL,
        [styles.selected]: selected,
        [styles[size]]: size,
    }, [selected]);
    const style = useMemo(() => {
        return {
            '--text-color': textColor,
            '--text-color-selected': textColorSelected,
        };
    }, []);
    return (_jsxs("div", { className: listOptionClass, ref: ref, style: style, children: [showCheck && (_jsx("span", { className: cls(styles.icon, {
                    [styles.rtl]: RTL,
                    [styles.selected]: selected,
                }), children: _jsx(CheckIcon, {}) })), _jsx("span", { className: cls(styles.value, {
                    [styles.value_selected]: selected,
                }), children: name })] }));
}, (prev, next) => {
    return prev.selected === next.selected;
});
ListItemContent.displayName = 'ListItemContent';
export { ListItemContent };
